
// integrate and transform data
function createDepartmentTable(data) {
    let departments = data.departments;
    let result = {};
    for (let i = 0; i < departments.length; i++)
        result[departments[i].number] = departments[i];
    result['lastUpdated'] = data.latest_term;
    return result;
}

/* sections = [ { instructors: [ (Object) ], term: (int), _a: (int), _ab: (int), ... } ]
 => instructors = { <eid_hash>: { 'eid_hash': (str), 'name': (str), 'sections': { <term>: (Object) }, 'total': (int), 'average': (int) }, 'last_term': (int) }
 example:
 { b3c45d69a1:
   { eid_hash: 'b3c45d69a1',
     name: 'JAMES SKRENTNY',
     sections:
      { '1072': [Object], <-- { _a: (int), _ab: (int), ... }
        '1074': [Object],
        '1082': [Object],
        '1132': [Object],
        '1134': [Object],
        '1142': [Object],
        '1144': [Object],
        '1152': [Object],
        '1154': [Object],
        '1162': [Object],
        '1164': [Object] } },
    ...
*/
function aggregateSectionData(sections) { // for each instructor, each year
    let instructors = {};
    for (let section of sections) {
        let term = section.term;

        for (let instructor of section.instructors) {
            let eidHash = instructor.eid_hash;
            if (!(eidHash in instructors))
                instructors[eidHash] = { 'eid_hash': eidHash, 'name': instructor.name,
                    'sections': {}, 'total': 0, 'average': 0, 'last_term': null };
            if (!(term in instructors[eidHash].sections)) {
                instructors[eidHash].sections[term] = { 'total': 0, 'average': 0 };
                for (let prop of Object.keys(section)) {
                    if (prop === 'instructors' || prop === 'term') continue;
                    instructors[eidHash].sections[term][prop] = 0;
                }
            }
            let total = 0;
            let average = 0;
            for (let prop of Object.keys(section)) {
                let gradePoint = _getGradePoint(prop);
                let gradeCount = (gradePoint > 0 || prop === '_f') ? section[prop] : 0;
                instructors[eidHash].sections[term][prop] += section[prop];

                // computing section overall GPA
                total += gradeCount;
                average += gradePoint * gradeCount;
            }
            instructors[eidHash].sections[term].total += total;
            instructors[eidHash].sections[term].average += average;

            instructors[eidHash].total += total;
            instructors[eidHash].average += average;
                // instructors[eidHash].sections[term].average /= total;
        }
    }
    Object.keys(instructors).forEach((eidHash) => {
        let total = instructors[eidHash].total;
        if (total > 0) instructors[eidHash].average /= total;
        instructors[eidHash].last_term = _getLastTerm(Object.keys(instructors[eidHash].sections));

        Object.keys(instructors[eidHash].sections).forEach((term) => {
            let total = instructors[eidHash].sections[term].total;
            if (total > 0) instructors[eidHash].sections[term].average /= total;
        });
    });
    return instructors;
}

function _getLastTerm(terms) {
    let maxTerm = 0;
    for (let term of terms) {
        let _term = parseInt(term)
        if (maxTerm < _term ) maxTerm = _term;
    }
    return maxTerm;
}

function _getGradePoint(letterGrade) {
    switch (letterGrade) {
        case '_a': return 4;
        case '_ab': return 3.5;
        case '_b': return 3;
        case '_bc': return 2.5;
        case '_c': return 2;
        case '_d': return 1;
        default: return 0;
    }
}

export { aggregateSectionData, createDepartmentTable };


// WEBPACK FOOTER //
// ./src/common/data.js